import { render, staticRenderFns } from "./DocApp.vue?vue&type=template&id=568d25b5&scoped=true"
import script from "./DocApp.vue?vue&type=script&lang=js"
export * from "./DocApp.vue?vue&type=script&lang=js"
import style0 from "./DocApp.vue?vue&type=style&index=0&id=568d25b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568d25b5",
  null
  
)

export default component.exports